<template>
  <div class="chre-box">
      产品中心
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.chre-box {
  margin-top: 40px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
}
</style>